import React, { useEffect, useState } from "react";
import SideBar from "../navigation/sidebar/SideBar";
import NavBar from "../navigation/topnav/NavBar";
import { SlRefresh } from "react-icons/sl";
import Loader from "../gif/loader.gif";
import axios from "axios";
import RowTitles from "../components/RowTitles";
import TableComp from "../components/TableComp";
import { CiSearch } from "react-icons/ci";
import { IoCloseOutline } from "react-icons/io5";
import { PiUsersBold } from "react-icons/pi";
import { IoMdAdd } from "react-icons/io";
import { useNavigate, useParams } from "react-router-dom";

const MemberList = () => {
  const navigate = useNavigate();
  //
  const [data, setData] = useState([]);
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  //
  const getMembers = async () => {
    setLoading(!loading);
    try {
      const res = await axios.get(
        `https://ntcapi-a4fdbbdfb3gactbd.southafricanorth-01.azurewebsites.net/api/get-members`
      );
      let retcode = res.data;
      setMembers(retcode);
      setData(retcode);
      //stop loading
      setLoading(false);
    } catch (error) {
      //stop loading
      setLoading(false);
      console.log("post error =>" + error);
    }
  };
  //
  const searchItem = () => {
    const filteredData = members.filter(
      (item) =>
        item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.mnumber.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.surname.toLowerCase().includes(searchTerm.toLowerCase())
    );
    console.log(filteredData);
    setMembers(filteredData);
  };
  //
  const reloadData = () => {
    setSearchTerm("");
    setMembers(data);
  };
  const reloadTable = () => {
    getMembers();
  };
  const register = () => {
    navigate("/register");
  };
  useEffect(() => {
    getMembers();
  }, []);
  return (
    <div className="d-flex" style={{ backgroundColor: "#f1f5f7" }}>
      <SideBar />
      {/* Main Content */}
      <div className="flex-grow-1">
        {/* Header */}
        <NavBar />
        <div className="container-fluid mt-4">
          <RowTitles title={"Dashboad"} child={"All registered members"} />
          <div className="row">
            <div className="col-md-6">
              <div className="input-group col-md-3 mb-3">
                <span className="input-group-append ml-3" onClick={reloadData}>
                  <div className="btn btn-outline-secondary py-2  border-left-0 border">
                    <PiUsersBold className="me-2" />
                    {data.length}
                  </div>
                </span>
                <input
                  className="form-control py-2 border-right-0 border"
                  placeholder="search member name"
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <span className="input-group-append" onClick={searchItem}>
                  <div className="btn btn-outline-secondary py-2  border-left-0 border">
                    <CiSearch />
                  </div>
                </span>
                <span className="input-group-append ml-3" onClick={reloadData}>
                  <div className="btn btn-outline-secondary py-2  border-left-0 border">
                    <IoCloseOutline />
                  </div>
                </span>
              </div>
            </div>
            <div className="col-md-6 text-end">
              <div className="row" style={{ display: "flex" }}>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <button
                    className="bg-danger text-white rounded border-0 p-1"
                    variant="outline-primary"
                    style={{ marginRight: "10px" }}
                    onClick={getMembers}
                  >
                    <SlRefresh size={25} />
                  </button>
                  <button
                    className="bg-success text-white rounded border-0 p-1"
                    variant="outline-primary"
                    onClick={register}
                  >
                    <IoMdAdd size={25} /> Register
                  </button>
                </div>
              </div>
            </div>
          </div>
          {loading ? (
            <img src={Loader} alt="QR Code" width={"50"} height={"50"} />
          ) : (
            <TableComp
              members={members && members}
              itemsPerPage={10}
              reloadTable={reloadTable}
            />
          )}
        </div>
      </div>
    </div>
  );
};
export default MemberList;
